import heroImage from "img/partners/hero.webp";
import React from "react";
import { Button } from "web/react/emo/button/button";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { scrollToSection } from "web/react/pages/partners/scroll-to-section";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./partners-hero.css";

export default function PartnersHero(): JSX.Element {
    const sectionRef = useSectionImpression("hero", 1);

    function handleCtaClick(): void {
        analytics.event({
            category: "partners_hero",
            action: "clicked",
            label: "sell_on_lyst_shop",
        });
        scrollToSection("contact-form");
    }

    return (
        <section ref={sectionRef} className={styles.section}>
            <div className={styles.imageContainer}>
                <img src={heroImage} alt="" className={styles.image} />
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.contentInner}>
                    <Heading textStyle="hero-xl" as="h1">
                        {gettext("partners.hero.headline")}
                    </Heading>
                    <Text textStyle="body" color="secondary">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: gettext("partners.hero.body"),
                            }}
                        />
                    </Text>
                    <Button
                        className={styles.ctaButton}
                        variant="primary"
                        title={gettext("partners.nav.sell_on_lyst_shop")}
                        onClick={handleCtaClick}
                    />
                </div>
            </div>
        </section>
    );
}
